import isEmpty from 'lodash/isEmpty';
import { type Observable as ObservableType, Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/switchMap';
import {
	type ClearIssueChildrenMentionsOptimisticAction,
	clearIssueChildrenMentionsOptimistic,
} from '../../state/actions/issue-children';

import {
	type ClearIssueMentionsOptimisticAction,
	clearIssueMentionsOptimistic,
} from '../../state/actions/issue/mentions';

import { type OpenIssueModalAction, OPEN_ISSUE_MODAL } from '../../state/actions/issue/modal';
import { issueChildrenTypeIdsSelector } from '../../state/selectors/issue-type/issue-type-selectors';
import { boardIssuesAndChildrenSelector } from '../../state/selectors/issue/board-issue-selectors';
import { getIssueOrIssueChildrenByKey } from '../../state/selectors/issue/issue-selectors';
import type { ActionsObservable, MiddlewareAPI } from '../../state/types';

export function clearMentionsEpic(
	action$: ActionsObservable,
	store: MiddlewareAPI,
): ObservableType<ClearIssueChildrenMentionsOptimisticAction | ClearIssueMentionsOptimisticAction> {
	return action$.ofType(OPEN_ISSUE_MODAL).switchMap((action: OpenIssueModalAction) => {
		const state = store.getState();
		const allIssueAndIssueChildren = boardIssuesAndChildrenSelector(state);

		// when the user opens the issue modal directly via the url
		// this epic gets triggered before issue data is populated
		// .: we skip checking for and clearing mentions for this case
		if (!isEmpty(allIssueAndIssueChildren)) {
			const issueId = getIssueOrIssueChildrenByKey(state, action.payload.issueKey)?.id;
			const isIssueIdUndefined = issueId === undefined;
			const issueChildrenTypeId = issueChildrenTypeIdsSelector(state);

			if (!isIssueIdUndefined && allIssueAndIssueChildren[issueId]?.mentions) {
				if (issueChildrenTypeId.includes(String(allIssueAndIssueChildren[issueId].typeId))) {
					return Observable.of(clearIssueChildrenMentionsOptimistic(issueId));
				}
				return Observable.of(clearIssueMentionsOptimistic(issueId));
			}

			return Observable.empty();
		}
		return Observable.empty();
	});
}
